import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HeroSection.css';

function HeroSection({
  backgroundImage,
  title,
  subtitle,
  ctaText = 'Get Your Free Quote',
  ctaLink = '/contact',
  overlay = true,
}) {
  const navigate = useNavigate();

  return (
    <section
      className="hero"
      style={backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : undefined}
    >
      {overlay && <div className="hero__overlay" />}
      <div className="hero__content container">
        <h1 className="hero__title">{title}</h1>
        {subtitle && <p className="hero__subtitle">{subtitle}</p>}
        <button
          className="btn btn--accent btn--lg hero__cta"
          onClick={() => navigate(ctaLink)}
        >
          {ctaText}
        </button>
      </div>
    </section>
  );
}

export default HeroSection;
